<template>
<v-card>
  <v-card-title>Edit item</v-card-title>
  <v-card-text>
    <stock-item-select :key="item && item.id" ref="select" v-model="selectedItem" class="mt-2"></stock-item-select>
    <v-text-field v-model.number="quantity" label="Qty" type="number"
                  min="1" hide-details class="mt-3"></v-text-field>
  </v-card-text>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn text @click="$emit('close')">Cancel</v-btn>
    <v-btn text color="primary" :disabled="!selectedItem" @click="save">Save</v-btn>
  </v-card-actions>
</v-card>
</template>

<script>
import * as api from '../../api'
import StockItemSelect from './StockItemSelect'

export default {
  name: 'EditLoadListItem',
  components: { StockItemSelect },
  props: {
    item: { type: Object, default: null }
  },
  data() {
    return {
      selectedItem: null,
      quantity: 1
    }
  },
  watch: {
    item(val) {
      if (val) {
        this.selectedItem = { id: val.stock_item_id, name: val.name }
        this.quantity = val.quantity
      }
    }
  },
  methods: {
    async save() {
      const stockItem = await this.$refs.select.resolveAndClear()
      if (!stockItem) return
      await api.put(`/load-list-item/${this.item.id}`, {
        stock_item_id: stockItem.id,
        quantity: this.quantity
      })
      this.$emit('saved')
      this.$emit('close')
    }
  },
  mounted() {
    if (this.item) {
      const { stock_item_id, name, quantity } = this.item
      this.selectedItem = { id: stock_item_id, name }
      this.quantity = quantity
    }
  }
}
</script>
